import { useTranslation } from 'react-i18next';
import { useFileForm } from '../hooks/useFileForm';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FileForm({ person }) {
    const { t } = useTranslation();
    const {
        fileFormRegister,
        fileErrors,
        fileTypes,
        isActiveChecked,
        setFileValue,
        fileData,
        handleEdit,
        handleDelete,
        isEditing,
        handleSubmit,
        submitFileForm,
        handleCancel,
        handleFileChange,
        selectedFile,
        isSubmitted
    } = useFileForm(person);

    const onFileSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(submitFileForm)(e);
    };

    return (
        <div className="file-form-container">
            <h3 className="form-subtitle">
                {t('persons.file.title', {
                    name: [person.name, person.fathersName, person.surname]
                        .filter(Boolean)
                        .join(' ')
                })}
            </h3>

            <div className="form-content">
                <div className="form-section">
                    <form onSubmit={onFileSubmit}>
                        <div className="form-input-wrapper">
                            <span className="span-bold">{t('persons.file.type')} <span className="required">*</span></span>
                            <div className='form-input-fields'>
                                <select
                                    name="personsFileTypeId"
                                    className={`form-control ${fileErrors.personsFileTypeId ? 'is-invalid' : ''}`}
                                    {...fileFormRegister('personsFileTypeId')}
                                    disabled={isEditing}
                                >
                                    <option value="">{t('common.select')}</option>
                                    {fileTypes.map(type => (
                                        <option key={type.id} value={Number(type.id)}>
                                            {type.allowedTypes}
                                        </option>
                                    ))}
                                </select>
                                {!isEditing && fileErrors.personsFileTypeId && (
                                    <div className="invalid-feedback">{fileErrors.personsFileTypeId.message}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-input-wrapper">
                            <span className="span-bold">{t('persons.file.file')} {!isEditing && <span className="required">*</span>}</span>
                            <div className='form-input-fields'>
                                <input
                                    type="file"
                                    name="file"
                                    className={`form-control ${!isEditing && isSubmitted && !selectedFile ? 'is-invalid' : ''}`}
                                    onChange={handleFileChange}
                                    disabled={isEditing}
                                />
                                {!isEditing && isSubmitted && !selectedFile && (
                                    <div className="invalid-feedback">{t('validation.person.file.fileRequired')}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-input-wrapper">
                            <span className="span-bold">{t('persons.file.description')}</span>
                            <div className='form-input-fields'>
                                <input
                                    type="text"
                                    name="description"
                                    placeholder={t('persons.file.description')}
                                    className={`form-control ${fileErrors.description ? 'is-invalid' : ''}`}
                                    {...fileFormRegister('description')}
                                />
                                {fileErrors.description && (
                                    <div className="invalid-feedback">{fileErrors.description.message}</div>
                                )}
                            </div>
                        </div>

                        <div className="form-input-wrapper">
                            <span className="span-bold">{t('persons.file.active')}</span>
                            <div className='form-input-fields'>
                                <div className="checkbox-group">
                                    <div className="input-checkbox-wrapper">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            {...fileFormRegister('active')}
                                            checked={isActiveChecked}
                                            onChange={(e) => setFileValue('active', e.target.checked)}
                                        />
                                        <label>{t('persons.file.active')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="file-form-controls">
                            <button 
                                type="button"
                                className={`form-btn ${isEditing ? 'btn-orange' : 'btn-green'}`}
                                onClick={handleSubmit(submitFileForm)}
                            >
                                {isEditing ? t('common.edit') : t('common.add')}
                            </button>
                            {isEditing && (
                                <button 
                                    type="button" 
                                    className="btn-gray form-btn" 
                                    onClick={handleCancel}
                                >
                                    {t('common.cancel')}
                                </button>
                            )}
                        </div>
                    </form>
                </div>

                <div className="table-section">
                    <div className="file-list-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>{t('persons.file.file')}</th>
                                    <th>{t('persons.file.type')}</th>
                                    <th>{t('persons.file.description')}</th>
                                    <th>{t('persons.file.active')}</th>
                                    <th>{t('common.actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fileData?.map((file, index) => (
                                    <tr key={index}>
                                        <td>{file.filename}</td>
                                        <td>{file.personsFileType.allowedTypes}</td>
                                        <td>{file.description}</td>
                                        <td>
                                            <input 
                                                type="checkbox" 
                                                checked={file.isActive}
                                                disabled
                                            />
                                        </td>
                                        <td className="action-buttons">
                                            <FontAwesomeIcon 
                                                icon={faEdit} 
                                                className="action-icon edit"
                                                onClick={() => handleEdit(file)}
                                            />
                                            <FontAwesomeIcon 
                                                icon={faTrash} 
                                                className="action-icon delete"
                                                onClick={() => handleDelete(file.id)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
} 